module.exports = __webpack_public_path__ + "img/avatar7.dde30476.png";